export default __webpack_public_path__ + "static/media/juliette_has_a_gun.f4b4572d.png";